import { atom } from "recoil";
import { Paginator } from "../model";

export const teamsPaginatorState = atom<Paginator | undefined>({
  key: 'teamsPaginatorState',
  default: undefined,
});